import request from '@/utils/request';
export function payInfoList(data) {
  return request.post('admin/pay-info/list', data);
}
export function payInfoRefundList(data) {
  return request.post('admin/pay-info/refund-list', data);
}
export function refundCheck(data) {
  return request.post('admin/pay-info/refund-check', data);
}
export function payDetailList(data) {
  return request.post('admin/pay-info/pay-detail-list', data);
}